export { default } from './ClientSales';
